import { Loader, OptimusProvider, PageLayout, useBreadcrumbs } from '@mews-commander/ui';
import { TemplateForm } from '../components/templateForm/TemplateForm';
import { useInitialValues } from '../components/templateForm/hooks/useInitialValues';

export const TemplateDetails = ({ templateId }: { templateId: string }) => {
    const breadcrumbs = useBreadcrumbs();
    const { data, isFetching } = useInitialValues(templateId);
    return (
        <OptimusProvider density="spacious">
            <PageLayout breadcrumbs={breadcrumbs} padded>
                {isFetching ? <Loader /> : <TemplateForm initialValues={data} templateId={templateId} />}
            </PageLayout>
        </OptimusProvider>
    );
};
